module.exports = __webpack_public_path__ + "static/media/A2.c9c841d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/A2.mp4
// module id = TGW0
// module chunks = 8